// src/components/intake/IntakeMessage.js
//
// Ticket 061. A title, a sentence and up to two buttons. Used for the
// non-question stages (advisor account, not available, failed, nothing found).

import React from 'react'

export default function IntakeMessage({ title, body, primary, secondary, busy }) {
  return (
    <div className="intake-holding">
      <h1 className="triage-question">{title}</h1>
      {body && <p className="triage-hint">{body}</p>}
      {busy && <div className="app-spinner" role="status" aria-label="Working" />}
      <div className="intake-actions">
        {primary && <button type="button" className="btn-primary" onClick={primary.onClick}>{primary.label}</button>}
        {secondary && <button type="button" className="btn-secondary" onClick={secondary.onClick}>{secondary.label}</button>}
      </div>
    </div>
  )
}
